import React from 'react'
import styled, {css} from 'styled-components'
import {Button, Link} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'

export const ExpiredPageComponent = styled.div`
  color: rgba(0,0,0,0.55);
  padding: 0 2rem;
  padding-top: 12rem;
  font-size: 13px;
  ${props => props.centered && css`
    text-align: center;
  `}
  ${props => props.grayNavbar && css`
    .navbar {
      background-color: ${getColor('gray120')};
    }
  `}
  .useful-links {
    text-align: center;
    margin-top: 2rem;
    a {
      text-decoration: none;
      ~ a {
        margin-left: .5rem;
        :before {
          content: '-';
          margin-right: .5rem;
          text-decoration: none;
          color: ${getColor('gray180')};
        }
      }
    }
  }
  @media (max-width: 440px) {
    padding: 0 1rem;
    padding-top: 6rem;
    .useful-links a {
      display: block;
      text-align: center;
      ~ a {
        :before {
          content: none;
        }
      }
  }
`

export const ContentBox = styled.div`
  padding: 3rem;
  background: white;
  border-radius: 6px;
  max-width: 44rem;
  margin: 0 auto;
  text-align: center;
  box-shadow: 0 0 3px rgba(0,0,0,0.15);
  h2 {
    font-size: 19px;
    font-weight: 600;
    margin-bottom: .5rem;
    line-height: 21px;
  }
  img {
    width: 80px;
    margin: 0 auto;
    margin-bottom: 1rem;
    ${props => props.topImage && css `
      width: 120px;
      margin-top: -90px;
    `}
  }
  ${Button} {
    margin-top: 1.5rem;
  }
  @media (max-width: 440px) {
    padding: 3.5rem 2rem;
    ${props => props.topImage && css `
      margin-top: 6rem;
    `}
  }
`

export class ExpiredShare extends React.PureComponent {

  render() {
    return <ExpiredPageComponent>
      <div className="navbar">
        <Link to="/" className="logo">Horos Cloud</Link>
      </div>
      <ContentBox>
        <img src="/public/expired-icon.png" alt="Expired" />
        <h2>This report is no longer available.</h2>
        <p>The shared report link you are accessing has expired and you are no longer able to view it. Report links expire in 48 hours for security reasons.</p>
        <p>In case you need to be granted access again, please reach out to the person who shared this report with you and ask for sharing again.</p>
        <Button.Link highlight skipTo="/signIn">Access Horos Cloud</Button.Link>
      </ContentBox>
    </ExpiredPageComponent>
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/public/ExpiredShare.jsx